var h = Object.defineProperty, S = Object.defineProperties;
var v = Object.getOwnPropertyDescriptors;
var g = Object.getOwnPropertySymbols;
var k = Object.prototype.hasOwnProperty, C = Object.prototype.propertyIsEnumerable;
var p = (t, s, e) => s in t ? h(t, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[s] = e, _ = (t, s) => {
  for (var e in s || (s = {}))
    k.call(s, e) && p(t, e, s[e]);
  if (g)
    for (var e of g(s))
      C.call(s, e) && p(t, e, s[e]);
  return t;
}, y = (t, s) => S(t, v(s));
var m = (t, s, e) => new Promise((r, c) => {
  var u = (a) => {
    try {
      o(e.next(a));
    } catch (l) {
      c(l);
    }
  }, f = (a) => {
    try {
      o(e.throw(a));
    } catch (l) {
      c(l);
    }
  }, o = (a) => a.done ? r(a.value) : Promise.resolve(a.value).then(u, f);
  o((e = e.apply(t, s)).next());
});
import { u as A, a as F } from "./query-client-DZ5Df1It.js";
import { m as L, r as N, u as b, o as q, b as x, c as i, e as n, f as d, F as B, p as I, g as M, t as P, k as R, h as T } from "./define-element-XpjsV6s1.js";
import { P as V } from "./ProductList-3BayW812.js";
import { _ as w } from "./_plugin-vue_export-helper-CHgC5LLL.js";
function H() {
  A();
  const t = F({
    queryKey: ["categories"],
    queryFn: () => m(null, null, function* () {
      const e = yield N("cart/categories");
      return e.error ? [] : Array.isArray(e) ? e : Object.values(e);
    })
  }), s = L(() => (t.data.value ? [...t.data.value] : []).filter((r) => r.status === "Active").sort((r, c) => r.sort - c.sort));
  return y(_({}, t), {
    categoriesSortedAndFiltered: s
  });
}
const Q = {
  class: "offset-categories",
  ref: "container"
}, j = {
  key: 0,
  class: "offset-categories-loading"
}, D = { key: 1 }, E = {
  key: 2,
  class: "offset-categories-list"
}, K = { class: "offset-category-title" }, O = ["innerHTML"], z = {
  __name: "Categories",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(t) {
    const s = t, { isPending: e, categoriesSortedAndFiltered: r } = H(), c = b("container");
    return q(() => {
      x(c.value, s.inheritStyle);
    }), (u, f) => (i(), n("div", Q, [
      d(e) ? (i(), n("div", j, "Loading...")) : d(r).length ? (i(), n("div", E, [
        (i(!0), n(B, null, I(d(r), (o) => (i(), n("div", {
          key: o.id,
          class: "offset-category"
        }, [
          M("h2", K, P(o.name), 1),
          o.description ? (i(), n("div", {
            key: 0,
            class: "offset-category-description",
            innerHTML: o.description
          }, null, 8, O)) : R("", !0),
          T(V, {
            collectionSlug: o.slug,
            inheritStyle: t.inheritStyle
          }, null, 8, ["collectionSlug", "inheritStyle"])
        ]))), 128))
      ])) : (i(), n("div", D, "No categories found"))
    ], 512));
  }
}, Y = /* @__PURE__ */ w(z, [["__scopeId", "data-v-5b176a57"]]);
export {
  Y as C
};
